var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 63.931C46.7633 63.931 52.3635 62.2322 57.1269 59.0495C61.8902 55.8667 65.6028 51.3429 67.7951 46.0502C69.9875 40.7574 70.5611 34.9334 69.4434 29.3146C68.3258 23.6959 65.5671 18.5347 61.5162 14.4838C57.4653 10.4329 52.3041 7.67422 46.6854 6.55658C41.0666 5.43894 35.2426 6.01255 29.9499 8.20488C24.6571 10.3972 20.1333 14.1098 16.9505 18.8732C13.7678 23.6365 12.069 29.2367 12.069 34.9655V49.931L3.37931 41.2414L0 44.6207L14.4828 59.1035L28.9655 44.6207L25.5862 41.2414L16.8965 49.931V34.9655C16.8965 30.1915 18.3122 25.5247 20.9645 21.5552C23.6168 17.5858 27.3867 14.4919 31.7973 12.665C36.2079 10.838 41.0613 10.36 45.7436 11.2914C50.4259 12.2228 54.7268 14.5217 58.1026 17.8974C61.4783 21.2732 63.7772 25.5742 64.7086 30.2565C65.64 34.9388 65.162 39.7921 63.335 44.2027C61.5081 48.6133 58.4143 52.3832 54.4448 55.0355C50.4753 57.6878 45.8085 59.1035 41.0345 59.1035V63.931Z",
    fill: "#090057"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.bda44d0a2cfdb0fb38ac265a295358a6.svg";
export { ForwardRef as ReactComponent };